// extracted by mini-css-extract-plugin
module.exports = {"container":"messagebox_container__1MeK-","button-container":"messagebox_button-container__24D0D"};